 

function LogoComponent() {
  return (
    <a href='#/' className='absolute top-10 right-[10%] tablet:right-[5%] text-white-color text-3xl tablet:text-5xl'>
        <span className='text-primary'>
            NE
        </span>
        <span className='text-white-color'>
            LO
        </span>
    </a>
  )
}

export default LogoComponent